import BaseAPI from "./apiBase";

/**********************************************************************************************
 * 
 * Daily Extractions
 * 
 /*********************************************************************************************/

export async function getDailyExtractionSessions(params) {
    const result = await BaseAPI.simpleGetAsync("/dailyextractions", { params: params });

    return result.data;
}

/**
 * Gets a specific extraction session dataset, note it just calls the search function with different parameters
 * @param {*} params 
 */
export async function getDailyExtractionSession(params) {
    return await getDailyExtractionSessions(params);
}

export async function createNewDailyExtractionSession(data){
    const result = await BaseAPI.simplePostAsync("/dailyextractions", data);

    return result.data;
}

export async function createDailyExtractionSessionEntry(data) {
    const result = await BaseAPI.simplePostAsync("/dailyextraction/entry", data);

    return true;
}

export async function updateDailyExtractionSessionEntry(data){
    const result = await BaseAPI.simplePostAsync("/dailyextraction/entry", data);

    return true;
}

export async function endDailyExtractionSession(data) {
    const result =  await BaseAPI.simplePostAsync("/dailyextractions/end", data);

    return result.data;
}

export async function getDailyExtractionSessionEntries(params){
    const result = await BaseAPI.simpleGetAsync("/dailyextraction/entry", { params: params });

    return result.data;
}

export async function refrigerateVenom(data) {
    const result = await BaseAPI.simplePostAsync("/dailyextractions/refrigerate", data);

    return result.data;
}

export async function getLatestExtractionSessionData(specimenID) {
    const result = await BaseAPI.simpleGetAsync("/dailyextraction/lastextraction", { params: { specimenID } });

    return result.data;
}

export async function deleteExtractionSession(sessionID){
    const result = await BaseAPI.simpleDeleteAsync("/dailyextractions/",{ params:{ sessionID }});

    return result.data;
}

export async function deleteDailyExtractionRecord(recordID){
    const result = await BaseAPI.simpleDeleteAsync("/dailyextraction/entry",{ params:{ recordID }});

    return result.data;
}

/**********************************************************************************************
 *
 * Species Batch Pools
 *
 /*********************************************************************************************/

export async function getSpeciesBatchPools(params) {
    const result = await BaseAPI.simpleGetAsync("/speciesbatchpools", { params: params });

    return result.data;
}

export async function saveSpeciesBatchPool(data) {
    const result = await BaseAPI.simplePostAsync("/speciesbatchpools", data);

    return result.data;
}

export async function getMonthlyPoolsAvailableForSpeciesBatchPools(speciesID, isExternal) {
    const result = await BaseAPI.simpleGetAsync("/speciesbatchpools/availablemonthlypools", { params: { speciesID, isExternal } });

    return result.data;
}

export async function addMonthlyPoolsToSpeciesBatchPool(monthlyPoolIDs, speciesBatchPoolID) {
    const data = {
        monthlyPoolIDs: monthlyPoolIDs,
        speciesBatchPoolID: speciesBatchPoolID
    };

    const result = await BaseAPI.simplePostAsync("/speciesbatchpools/addmonthlypoolstospeciesbatchpool", data);

    return result.data;
}

export async function createUpdateSpeciesBatchPool(data) {
    const result = await BaseAPI.simplePostAsync("/speciesbatchpools", data);

    return result.data;
}

/**********************************************************************************************
 *
 * Venom Lots
 *
 /*********************************************************************************************/

export async function getVenomLots(params) {
    const result = await BaseAPI.simpleGetAsync("/venomlots", { params: params });

    return result.data;
}

export async function saveVenomLot(data) {
    const result = await BaseAPI.simplePostAsync("/venomlots", data);

    return result.data;
}

export async function getSpeciesBatchPoolsAvailableForVenomLot(venomLotID) {
    const result = await BaseAPI.simpleGetAsync("/venomlots/availablespeciesbatchpools", { params: { venomLotID } });

    return result.data;
}

export async function addSpeciesBatchPoolsToVenomLot(speciesBatchPoolID,addedWeight,venomLotID,speciesID) {
    const data = {
        SpeciesBatchPoolID: speciesBatchPoolID,
        AddedWeight:addedWeight,
        VenomLotID: venomLotID,
        SpeciesID: speciesID
    };
    const result = await BaseAPI.simplePostAsync("/venomlots/addspeciesbatchpoolstovenomlot", data);

    return result.data;
}

/**********************************************************************************************
 *
 * Monthly Pooling
 *
 /*********************************************************************************************/

export async function createUpdateMonthlyPool(data) {
    const result = await BaseAPI.simplePostAsync("/monthlypools", data);

    return result.data;
}

export async function getMonthlyPools(params) {
    const result = await BaseAPI.simpleGetAsync("/monthlypools", { params: params });

    return result.data;
}

/**
 * Gets a specific monthly pool, note it just calls the search function with different parameters
 * @param {*} params 
 */
export async function getMonthlyPool(params) {
    return await getMonthlyPools(params);
}

export async function addExternallySuppliedVenom(data) {
    const result = await BaseAPI.simplePostAsync("/monthlypools/external", data);

    return result.data;
}

export async function addDailyExtractionsToMonthlyPool(data) {
    const result = await BaseAPI.simplePostAsync("/monthlypools/daily", data);

    return result.data;
}

export async function getMonthlyPoolDetails(params){
    const result = await BaseAPI.simpleGetAsync("/monthlypools/details", { params: params });

    return result.data;
}

export async function getMonthlyPoolAvailableSessions(speciesID) {
    const result = await BaseAPI.simpleGetAsync("/monthlypools/availablesessions", { params: { speciesID } });

    return result.data;
}

export async function getDailyMonthBatchRecord(monthlyPoolID) {
    const result = await BaseAPI.simpleGetAsync("/monthlypools/dailymonthbatchrecord", { params: { monthlyPoolID } });

    return result.data;
}

export async function getMonthlyPoolDocuments(monthlyPoolID){
    const result = await BaseAPI.simpleGetAsync("/monthlypools/documents", { params: { monthlyPoolID } });
    return result.data;
}

export async function deleteMonthlyPoolDocument(filePath,DocumentID) {
    const result =  await BaseAPI.simpleDeleteAsync("/monthlypools/documents", DocumentID);
    return result;
}